export const data = {
  accounts: [
    {
      account_id: "bLkJajE8xliPWD4oGqd4HXdzLZQXzKtoqyrgP",
      balances: {
        available: 100,
        current: 110,
        iso_currency_code: "USD",
        limit: null,
        unofficial_currency_code: null,
      },
      mask: "0000",
      name: "Plaid Checking",
      official_name: "Plaid Gold Standard 0% Interest Checking",
      subtype: "checking",
      type: "depository",
    },
    {
      account_id: "mmRke9yr5NszVgqLEW1qSkzWqDXkWNF4Jw8R8",
      balances: {
        available: 200,
        current: 210,
        iso_currency_code: "USD",
        limit: null,
        unofficial_currency_code: null,
      },
      mask: "1111",
      name: "Plaid Saving",
      official_name: "Plaid Silver Standard 0.1% Interest Saving",
      subtype: "savings",
      type: "depository",
    },
    // {
    //   account_id: "y4NeabqAVgfvWoj69KbjHGvKnzeGKdHKALpkv",
    //   balances: {
    //     available: null,
    //     current: 1000,
    //     iso_currency_code: "USD",
    //     limit: null,
    //     unofficial_currency_code: null,
    //   },
    //   mask: "2222",
    //   name: "Plaid CD",
    //   official_name: "Plaid Bronze Standard 0.2% Interest CD",
    //   subtype: "cd",
    //   type: "depository",
    // },
    {
      account_id: "9P1AvwrG8eClRBa8NKxaTxRk1yexkLFqDbMzb",
      balances: {
        available: null,
        current: 410,
        iso_currency_code: "USD",
        limit: 2000,
        unofficial_currency_code: null,
      },
      mask: "3333",
      name: "Plaid Credit Card",
      official_name: "Plaid Diamond 12.5% APR Interest Credit Card",
      subtype: "credit card",
      type: "credit",
    },
    // {
    //   account_id: "vxdPrRXpqLCjA84lEWG4SEjWAM9EWxcvR4VaL",
    //   balances: {
    //     available: 43200,
    //     current: 43200,
    //     iso_currency_code: "USD",
    //     limit: null,
    //     unofficial_currency_code: null,
    //   },
    //   mask: "4444",
    //   name: "Plaid Money Market",
    //   official_name: "Plaid Platinum Standard 1.85% Interest Money Market",
    //   subtype: "money market",
    //   type: "depository",
    // },
    // {
    //   account_id: "Rzd5e13R8PuJ8M5VQXn5Hd37ajxd7NtP4r57m",
    //   balances: {
    //     available: null,
    //     current: 320.76,
    //     iso_currency_code: "USD",
    //     limit: null,
    //     unofficial_currency_code: null,
    //   },
    //   mask: "5555",
    //   name: "Plaid IRA",
    //   official_name: null,
    //   subtype: "ira",
    //   type: "investment",
    // },
    {
      account_id: "6aQ8wBlogPI5XK3JBgM3unXeM7GneWc13Mnjv",
      balances: {
        available: null,
        current: 23631.9805,
        iso_currency_code: "USD",
        limit: null,
        unofficial_currency_code: null,
      },
      mask: "6666",
      name: "Plaid 401k",
      official_name: null,
      subtype: "401k",
      type: "investment",
    },
    // {
    //   account_id: "X475NwPz8MfBV1lQboalCQMwjgbQw8u1Ez8pB",
    //   balances: {
    //     available: null,
    //     current: 65262,
    //     iso_currency_code: "USD",
    //     limit: null,
    //     unofficial_currency_code: null,
    //   },
    //   mask: "7777",
    //   name: "Plaid Student Loan",
    //   official_name: null,
    //   subtype: "student",
    //   type: "loan",
    // },
    {
      account_id: "Dgb5rw7x8WuNXQ5dEGo5hVzlxeEVlgC4Q9Gz6",
      balances: {
        available: null,
        current: 56302.06,
        iso_currency_code: "USD",
        limit: null,
        unofficial_currency_code: null,
      },
      mask: "8888",
      name: "Plaid Mortgage",
      official_name: null,
      subtype: "mortgage",
      type: "loan",
    },
  ],
  item: {
    available_products: [
      "assets",
      "auth",
      "balance",
      "identity",
      "liabilities",
      "recurring_transactions",
    ],
    billed_products: ["transactions"],
    consent_expiration_time: null,
    error: null,
    institution_id: "ins_127989",
    name: "Bank of America",
    item_id: "kn9qemEJyafKGy1m6aV1FlAarjrbPMcWAQQEB",
    optional_products: null,
    products: ["transactions"],
    update_type: "background",
    webhook: "",
  },
  request_id: "QkEjYGjXzNLlH1H",
};
